'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["leftContent", "rightContent", "className", "footer"];
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TwoColumnLayout = _ref => {
  let {
      leftContent,
      rightContent,
      className,
      footer
    } = _ref,
    otherProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsxs("div", Object.assign({
    className: `${className} two-column-layout`
  }, otherProps, {
    children: [/*#__PURE__*/_jsx("div", {
      className: "left-column",
      children: leftContent
    }), /*#__PURE__*/_jsxs("div", {
      className: "right-column",
      children: [rightContent, footer]
    })]
  }));
};
export default TwoColumnLayout;